import React from 'react';
import {
    FaFacebookF,
    FaInstagram,
    FaLinkedinIn,
    FaYoutube,
    // FaEnvelope
} from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import './Footer.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-row">
                    <div className="footer-col">
                        <h4>Quick Links</h4>
                        <ul>
                            <li><a href="/about">About Us</a></li>
                            <li><a href="/activities.html">All Activities</a></li>
                            <li><a href="/bloglist">News & Blogs</a></li>
                            <li><a href="/help-us.html">Donation Details</a></li>
                        </ul>
                    </div>
                    <div className="footer-col">
                        <h4>Populars</h4>
                        <ul>
                            <li><a href="/irc-charity">IRC Clinics</a></li>
                            <li><a href="/irc-study">IRC Study Centre</a></li>
                            <li><a href="/irc-women">IRC Women Empowerment Centre</a></li>
                            <li><a href="/irc-technical">IRC Technical Institutes</a></li>
                        </ul>
                    </div>
                    <div className="footer-col">
                        <h4>Others</h4>
                        <ul>
                            <li><a href="https://pmny.in/HJ2AWtxjLqtp" target="" rel="noopener noreferrer">Donation Page</a></li>
                            <li><a href="https://www.youtube.com/@AdvFaizSyedOfficial" target="" rel="noopener noreferrer">Youtube Channel</a></li>
                            <li><a href="https://advfaizsyed.com/#home">Adv. Faiz Syed Website</a></li>
                            <li><a href="/privacy-policy">Privacy Policy</a></li>
                            <li><a href="/terms&conditions">Term & Conditions</a></li>
                        </ul>
                    </div>
                    <div className="footer-col">
                        <h4>Follow Us</h4>
                        <div className="social-links">
                            <a href="https://www.facebook.com/FaizAliSyed" target="_blank" rel="noopener noreferrer">
                                <FaFacebookF />
                            </a>
                             <a href="https://www.youtube.com/@AdvFaizSyedOfficial" target="_blank" rel="noopener noreferrer">
                                <FaYoutube />
                            </a>
                            <a href="https://x.com/advfaizsyed" target="_blank" rel="noopener noreferrer">
                                <FaXTwitter />
                            </a>
                             <a href="https://www.linkedin.com/in/advfaizsyed" target="_blank" rel="noopener noreferrer">
                                <FaLinkedinIn />
                            </a>
                            <a href="https://www.instagram.com/advfaizsyed" target="_blank" rel="noopener noreferrer">
                                <FaInstagram />
                            </a>
                           
                            
                        </div>
                        {/* <div className="newsletter">
                            <h5>Subscribe to our newsletter</h5>
                            <form>
                                <div className="input-with-icon">
                                    <input type="email" placeholder="Your Email" required />
                                    <FaEnvelope className="email-icon" />
                                </div>
                                <button type="submit">Subscribe</button>
                            </form>
                        </div> */}
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <p>&copy; Copyright {currentYear} IRC, All rights reserved, IRC Logo & Word is registered trademark ® of Islamic Research Centre Education & Welfare Trust, <br/>registered under the Trade Marks Act 1999, with registration number 6136579 & 6136577.</p>
            </div>
        </footer>
    );
};

export default Footer;